import { render, staticRenderFns } from "./InvisibleComponentGroup.vue?vue&type=template&id=255989a4"
import script from "./InvisibleComponentGroup.vue?vue&type=script&lang=js"
export * from "./InvisibleComponentGroup.vue?vue&type=script&lang=js"
import style0 from "./InvisibleComponentGroup.vue?vue&type=style&index=0&id=255989a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports